import React from 'react'
import Tittle from '../Components/Tittle'
import ImageSection from '../Components/ImageSection';
import SkillsSection from '../Components/SkillsSection';
import ServicesSection from '../Components/ServicesSection';
import design from '../img/design.svg';
import intelligence from '../img/intelligence.svg';
import gamedev from '../img/game-dev.svg';

function AboutPage() {
    return (
        <div className="AboutPage">
            <Tittle title={'About Me'} span={'About Me'} />
            <ImageSection />
            <Tittle title={'My Skills'} span={'My Skills'} />
            <div className="skillsContainer">
                <SkillsSection skill={'Javascript'} progress={'90%'} width={'90%'} />
                <SkillsSection skill={'Typescript'} progress={'80%'} width={'50%'} />
                <SkillsSection skill={'React Js'} progress={'90%'} width={'90%'} />
                <SkillsSection skill={'Node Js'} progress={'80%'} width={'80%'} />
                <SkillsSection skill={'Python'} progress={'70%'} width={'70%'} />
                <SkillsSection skill={'C++'} progress={'70%'} width={'90%'} />
                <SkillsSection skill={'Java'} progress={'70%'} width={'80%'} />
                <SkillsSection skill={'Deep Learning'} progress={'80%'} width={'80%'} />
                <SkillsSection skill={'Flutter'} progress={'76%'} width={'76%'} />
            </div>

            <Tittle title={'Services'} span={'Services'} />
            <div className="servives-container">
                <ServicesSection image={design} title={'Web development'} 
                text={''}
                />
                <ServicesSection image={intelligence} title={'Artificial Intelligence'} 
                text={''}
                />
                <ServicesSection image={gamedev} title={'Mobile App Development'} 
                text={''}
                />

                
            </div>

        </div>
    )
}

export default AboutPage;
